/**
 * O componente recebe as variáveis explicadas abaixo
 *
 * @param {HTMLElement} el - Elemento DOM que seleciona o componente em si
 * @param {Object} params  - Parâmetros para serem utilizados
 */

document.addEventListener("DOMContentLoaded", function () {
    const showSubMenu = document.getElementById("showSubMenu");
    const btnClose = document.getElementById("btnClose");
    const subMenu = document.getElementById("subMenu");
    const bgBeige = document.querySelector(".bg-beige");
    const filterButtons = document.querySelector(".filter-buttons");

    showSubMenu.addEventListener("click", function () {
        const isActive = subMenu.classList.contains("active");
        subMenu.classList.toggle("active", !isActive);
        showSubMenu.classList.toggle("active", !isActive);

        if (isActive) {
            bgBeige.style.backgroundColor = "";
            btnClose.style.display = "none";
            filterButtons.style.display = "block";
        } else {
            bgBeige.style.backgroundColor = "#F3F0EA";
            btnClose.style.display = "block";
            filterButtons.style.display = "none";
        }

    });

    btnClose.addEventListener("click", function () {
        subMenu.classList.remove("active");
        showSubMenu.classList.remove("active");
        bgBeige.style.backgroundColor = "";
        btnClose.style.display = "none";
        filterButtons.style.display = "block";
    });
});


document.getElementById('limit').addEventListener('change', function(event) {
    event.preventDefault();

    let params = new URLSearchParams(window.location.search);
    params.set('limit', this.value);

    window.location.search = params;
});

const limits = [15, 30, 60, 120];
let limit = new URLSearchParams(window.location.search).get('limit');

if (limit) {
    limit = parseInt(limit);
    document.getElementById('limit').value = limits.indexOf(limit) != -1 ? limit : 15;
}
